import React from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";

import { DownloadAllPortfolio } from "../../../templates/teacher/DownloadAllPortfolio";
import {
  Context,
  fetchSimpleTeachingMaterials,
  notFoundPath,
  fetchTemporaryToken,
  clearTemporaryToken,
  classDataPath,
} from "../../../teacherStore";
import useWaitApiCall from "../../../hooks/useWaitApiCall";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const params = useParams<{
    class_id: string;
  }>();
  const history = useHistory();
  const { state: locationState } = useLocation<{
    nameClass: string;
  }>();
  const class_id = parseInt(params.class_id);
  const nameClass = locationState?.nameClass;

  const links = React.useMemo(
    () => [
      {
        name: `クラスデータ`,
        to: classDataPath,
      },
      {
        name: nameClass ?? "",
        to: `${classDataPath}/${class_id}`,
        state: { nameClass },
      },
      {
        name: "振り返りシート一括ダウンロード",
        to: "#",
      },
    ],
    [class_id, nameClass],
  );

  React.useEffect(() => {
    dispatch(peep(fetchSimpleTeachingMaterials(class_id)));
  }, [class_id, peep, dispatch]);

  React.useEffect(() => {
    if (!nameClass) {
      history.replace(notFoundPath);
    }
  }, [history, nameClass]);

  const portfolioTeachingMaterials = React.useMemo(
    () =>
      state.simple_teaching_materials.filter(
        material => material.portfolio_type,
      ),
    [state.simple_teaching_materials],
  );

  const goBack = React.useCallback(
    () =>
      history.push(`${classDataPath}/${class_id}`, {
        nameClass,
      }),
    [class_id, history, nameClass],
  );

  const handleDownloadPDF = React.useCallback(() => {
    dispatch(peep(fetchTemporaryToken()));
  }, [dispatch, peep]);

  const handleClearPDFToken = React.useCallback(() => {
    dispatch(clearTemporaryToken());
  }, [dispatch]);

  return nameClass ? (
    <DownloadAllPortfolio
      calling={calling}
      class_id={class_id}
      pdfToken={state.temporaryToken}
      portfolioTeachingMaterials={portfolioTeachingMaterials}
      links={links}
      goBack={goBack}
      onDownloadPDF={handleDownloadPDF}
      onClearPDFToken={handleClearPDFToken}
    />
  ) : null;
};
